import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission, SocketEvents } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import type { SortableColumn } from 'components/table';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon, CommentIcon } from 'assets/icons';
import moment from 'moment';
import ModalView from './modal-view';
import ViewComments from './view-comments';
import { RevisionService } from 'services';
import qs from 'query-string';
import ModalAssignament from './modal-assignament';
import * as Jetemit from 'jetemit';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  area_id: '',
  person_type_id: '',
  since: '',
  until: '',
  sort_by: '',
  sort_direction: '',
};

const SORTABLE_COLUMNS: SortableColumn[] = [
  { index: 1, key: 'created_at', type: 'date' },
  { index: 2, key: 'area_name', type: 'string' },
  { index: 3, key: 'person_type_name', type: 'string' },
  { index: 4, key: 'user_full_name', type: 'string' },
  { index: 6, key: 'lawyer_full_name', type: 'string' },
  { index: 9, key: 'status', type: 'number' },
];

class AdminRevision extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'ID Orden',
      'Fecha',
      'Tipo de derecho',
      'Tipo de persona',
      'Cliente',
      'C.I.',
      'Abogado',
      'Inpre',
      'Motivo de cancelación',
      'Estatus',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    originalData: [] as any[],
    page: 1,
    last_page: 1,
    areas: [],
    person_types: [],
    item: null,
    visible: false,
    visible_assign: false,
    visible_comments: false,
    unsubscriber: () => {},
  };

  async componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Revisión Documental',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    const params = qs.parse(this.props.location.search);

    if (params.revision_number) {
      await this.setState({
        form: {
          ...this.state.form,
          search: params.revision_number,
        },
      });
    }

    this.setState({
      unsubscriber: Jetemit.on(SocketEvents.REVISION.ASSIGN_LAWYER, (data: any) => {
        this.load(true);
      }),
    });

    this.loadData();
    this.load();
  }

  componentWillUnmount() {
    this.state.unsubscriber();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await RevisionService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
      until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.revisions.rows,
      originalData: [...res.revisions.rows],
      last_page: res.revisions.count,
    });
  };

  loadData = async () => {
    const res: any = await RevisionService.admin.getAreas({
      withoutLoading: true,
    });
    this.setState({
      person_types: res.person_types || [],
      areas: res.areas || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  onServerSort = (key: string, direction: 'asc' | 'desc' | null) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          sort_by: direction ? key : '',
          sort_direction: direction ? direction.toUpperCase() : '',
        },
      },
      () => this.load(true),
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      item,
      visible: true,
    });
  };

  loadComments = async (withoutLoading: boolean = false) => {
    const res: any = await RevisionService.viewComments({
      revision_id: (this.state.item as any)?.id,
      withoutLoading,
    });

    return res;
  };

  onOpenComments = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible_comments: true,
      item,
    });
  };

  onCloseComments = (load: boolean = false) => {
    this.setState(
      {
        visible_comments: false,
        item: null,
      },
      () => load && this.load(true),
    );
  };

  onOpenAssign = (item: any) => {
    this.setState({
      visible_assign: true,
      item,
    });
  };

  onCloseAssign = (load: boolean = false) => {
    this.setState(
      {
        visible_assign: false,
        item: null,
      },
      () => load && this.load(true),
    );
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.REVISION_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.REVISION_STATUS.ACCEPTED:
        return Colors.green;
        break;

      case Constants.REVISION_STATUS.REJECTED:
        return Colors.danger;

      case Constants.REVISION_STATUS.NO_TAKEN:
        return Colors.redTable;
        break;

      case Constants.REVISION_STATUS.SEARCHING:
        return Colors.blue;

      case Constants.REVISION_STATUS.CANCELLED:
        return Colors.gray6;
    }
  };

  render() {
    const { visible, visible_assign, visible_comments } = this.state;

    return (
      <div id='admin-revision'>
        <Modal
          className='modal-view-revision'
          visible={visible}
          title='Documentos'
          onClose={() => this.onClose()}
        >
          <ModalView item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <Modal
          className='modal-assign-lawyer'
          visible={visible_assign}
          title=''
          hideHeader={true}
          onClose={() => this.onCloseAssign()}
        >
          {/* @ts-ignore */}
          <ModalAssignament item={this.state.item} onClose={() => this.onCloseAssign()} />
        </Modal>

        <Modal
          className='modal-comments'
          visible={visible_comments}
          title='Comentarios'
          onClose={() => this.onCloseComments()}
        >
          {/* @ts-ignore */}
          <ViewComments loadComments={() => this.loadComments()} />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-11 row'>
                <div className='col-md-2'>
                  <Input
                    value={this.state.form.search}
                    name='search'
                    placeholder='Cliente o abogado'
                    label='Buscar'
                    className='input-table'
                    onSubmit={() => this.load()}
                    onChange={(e: any) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.load(true);
                      }, 1000);
                      this.change(e);
                    }}
                  />
                </div>
                <div className='col-md-3'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de derecho'
                    name='area_id'
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.load(true);
                      })
                    }
                    value={this.state.form.area_id}
                    options={this.state.areas.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
                <div className='col-md-3'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de persona'
                    name='person_type_id'
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.load(true);
                      })
                    }
                    value={this.state.form.person_type_id}
                    options={this.state.person_types.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
                <div className='col-md-2'>
                  <DatePicker
                    label='Desde'
                    placeholder='Desde'
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'since',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.since}
                  />
                </div>
                <div className='col-md-2'>
                  <DatePicker
                    label='Hasta'
                    placeholder='Hasta'
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'until',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.until}
                  />
                </div>
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Revisión Documental'
          data={this.state.data.length}
          header={this.state.header}
          sortableColumns={SORTABLE_COLUMNS}
          serverSort={true}
          onServerSort={this.onServerSort}
          rightAlign={[10]}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i.number}</td>
                <td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
                <td>{i.area?.name}</td>
                <td>{i.person_type?.name}</td>
                <td>{i.user?.full_name}</td>
                <td>{i.user?.full_document}</td>
                <td>{i.lawyer?.full_name || '-'}</td>
                <td>{i.lawyer?.lawyer_document || '-'}</td>
                <td className='description'>
                  {i.cancel_reason ? (
                    <Tooltip title={i.cancel_reason}>
                      <span className='description-text'>{i.cancel_reason}</span>
                    </Tooltip>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  <div className='container-status' style={{ backgroundColor: this.getColor(i) }}>
                    <p>{i.status_text}</p>
                  </div>
                </td>
                <td className='text-right'>
                  {(i.status == Constants.REVISION_STATUS.NO_TAKEN ||
                    i.status == Constants.REVISION_STATUS.SEARCHING) && (
                    <span className='assign-lawyer' onClick={(e: any) => this.onOpenAssign(i)}>
                      Asignar
                    </span>
                  )}
                  <Tooltip title='Comentarios'>
                    <a
                      className='link-icon comment'
                      href='#'
                      onClick={(e: any) => this.onOpenComments(e, i)}
                    >
                      <img src={CommentIcon} />
                    </a>
                  </Tooltip>

                  <Tooltip title='Ver'>
                    <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminRevision);
